/**
 * The five parts an address held as text suggests, read by the split's
 * own parser (splitFreeTextAddress in api/_shared/geocode/acceptance.ts,
 * the reader tools/recon/split-stored-addresses.ts runs), so a dialog
 * opening on a text-only address offers what the split would write.
 *
 * The browser imports the parser itself rather than a copy. That module
 * and everything it imports are plain TypeScript with no package import;
 * src/lib/addressSuggestion.test.ts walks the chain and fails when one
 * appears, since the browser build and the UI suite install the root
 * packages only.
 *
 * A text the split keeps as text suggests nothing. The suggestion is
 * never saved by itself: the form opens on it, and only Save sends it.
 */
import { splitFreeTextAddress, type AddressSplitMode } from '../../api/_shared/geocode/acceptance';

export interface SuggestedAddressParts {
  line1: string | null;
  line2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

/** The parts the text reads as under the form's rule ('directory',
 *  'home' or 'street', the split's own modes); null for no text, or a
 *  text the split keeps. */
export function suggestAddressParts(text: string | null | undefined, rule: AddressSplitMode): SuggestedAddressParts | null {
  if (text === null || text === undefined || text.trim() === '') return null;
  const read = splitFreeTextAddress(text, rule);
  return read.kind === 'split' ? { ...read.parts } : null;
}
